import { GaAnalytics } from './GaAnalytics'
import { AnalyticsProvider } from './AnalyticsProvider'

// const providers: AnalyticsProvider[] = AppConfig.isDev ? [] : [GaAnalytics]
const providers: AnalyticsProvider[] = [GaAnalytics]
// In the future, we can wrap multiple analytics providers here

const Analytics: AnalyticsProvider = {
  trackScreen: (pathname, params) => {
    providers.forEach((p) => p.trackScreen(pathname, params))
  },
  logEvent: (event, params) => {
    providers.forEach((p) => p.logEvent(event, params))
  },
  setProperty(key, value) {
    providers.forEach((p) => p.setProperty(key, value))
  },
  trackLogin: (method) => {
    providers.forEach((p) => p.trackLogin(method))
  },
  setCustomer: (customer) => {
    providers.forEach((p) => p.setCustomer(customer))
  },
  setStaff: (staff) => {
    providers.forEach((p) => p.setStaff(staff))
  },
  setStore: (store) => {
    providers.forEach((p) => p.setStore(store))
  },
  setSession: (sessionId) => {
    providers.forEach((p) => p.setSession(sessionId))
  },
}

export default Analytics
